module.exports = __webpack_public_path__ + "img/resource-tech-image-40.853a42fb.jpg";